import './style/_index.scss';
import App from './components/app';

export default App;



// WEBPACK FOOTER //
// ./index.js